@if (modalOpen) {
  <div class="session-overlay">
    <div class="session-backdrop"></div>
    <div class="session-dialog">
      <p>
        Your session is about to expire due to inactivity.
        You'll be logged out in {{ remainingSeconds }} seconds.
      </p>
      <div class="session-actions">
        <button class="btn-secondary" (click)="logout()">Logout</button>
        <button class="btn-primary" (click)="staySignedIn()">Stay logged in</button>
      </div>
    </div>
  </div>
}